export const formOrderObjFromCart = (data = null) => {
    const entityDetails = data?.itemDetail?.entityDetails || null;
    const environmentDetails = data?.itemDetail?.catalogService?.catalogConfig?.environmentDetails || null;
    const catalogConfig = data?.itemDetail?.catalogService?.catalogConfig || null;
    return {
        appProfile: entityDetails?.name,
        ...(entityDetails?.name && {
            appProfileDetails: {
                label: entityDetails?.name,
                value: entityDetails?.name,
                data: { dataClassification: catalogConfig?.tags?.['pep-dataclassification'] },
            },
        }),
        ...(!entityDetails?.name && { appProfileDetails: null }),
        applicationOwner: null,
        applicationOwnerDetails: {
            name: entityDetails?.applicationManager,
            email: entityDetails?.applicationManagerEmail,
            gpid: entityDetails?.applicationManagerGpid,
        },
        entityDetails: {
            ...entityDetails,
            applicationOwnerDetails: {
                name: entityDetails?.applicationManager,
                email: entityDetails?.applicationManagerEmail,
                gpid: entityDetails?.applicationManagerGpid,
            },
            costCenter: entityDetails?.costCenter,
            projectName: entityDetails?.project,
            sector: entityDetails?.sector,
            recoveryPriority: entityDetails?.recoveryPriority,
        },
        tagsQc: { ...catalogConfig?.tags },
        sector: environmentDetails?.sector || null,
        businessCategory: catalogConfig?.tags?.['pep-business-category'] || null,
        environment: environmentDetails?.environment || null,
        region: environmentDetails?.region || null,
        regionDetails: { label: environmentDetails?.region || null, value: environmentDetails?.region || null },
        department: environmentDetails?.department,
        departmentDetails: { label: environmentDetails?.department, value: environmentDetails?.department },
        cluster: catalogConfig?.environmentDetails?.clusterName,
        clusterDetails: { label: catalogConfig?.environmentDetails?.clusterName, value: catalogConfig?.environmentDetails?.clusterName },
        subscriptionId: catalogConfig?.environmentDetails?.subscriptionId,
        appSupportMailId: catalogConfig?.appSupportMailId,
        project: catalogConfig?.project,
        aksNamespace: catalogConfig?.namespace,
        isValidAksNamespace: true,
        nodePool: catalogConfig?.nodePool,
        nodepoolDetails: { label: catalogConfig?.nodePool, value: catalogConfig?.nodePool },
        applicationUrl: catalogConfig?.applicationUrl,
        supportBackendCertificate: catalogConfig?.supportBackendCertificate,
        hCode: environmentDetails?.costCenter || null,
        ...(environmentDetails?.costCenter && {
            hCodeDetails: { label: environmentDetails?.costCenter, value: environmentDetails?.costCenter, projectName: environmentDetails?.projectName },
        }),
        ...(!environmentDetails?.costCenter && { hCodeDetails: null }),
        adGroup: catalogConfig?.adGroup || null,
        resourceGroup: environmentDetails?.resourceGroup || null,
        catalogCode: data?.itemDetail?.catalogService?.catalogServiceCode,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        catalogType: data?.itemDetail?.catalogService?.catalogType,
        cloudProvider: data?.itemDetail?.catalogService?.cloudProvider,
        cloudService: data?.itemDetail?.catalogService?.cloudService,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};

export const formOrderObjFromOrderDetails = (catalogServiceId = null, data = null) => {
    const entityDetails = data?.entityDetails || null;
    const catalog = data?.catalogServices?.find((item) => item?.catalogServiceId === catalogServiceId) || null;
    const catalogConfig = catalog?.catalogConfig || null;
    const environmentDetails = catalogConfig?.environmentDetails || null;

    return {
        appProfile: entityDetails?.name,
        ...(entityDetails?.name && {
            appProfileDetails: {
                label: entityDetails?.name,
                value: entityDetails?.name,
                data: { dataClassification: catalogConfig?.tags?.['pep-dataclassification'] },
            },
        }),
        ...(!entityDetails?.name && { appProfileDetails: null }),
        applicationOwner: null,
        applicationOwnerDetails: {
            name: entityDetails?.applicationManager,
            email: entityDetails?.applicationManagerEmail,
            gpid: entityDetails?.applicationManagerGpid,
        },
        entityDetails: {
            ...entityDetails,
            applicationOwner: entityDetails?.applicationManager,
            applicationOwnerDetails: {
                name: entityDetails?.applicationManager,
                email: entityDetails?.applicationManagerEmail,
                gpid: entityDetails?.applicationManagerGpid,
            },
            costCenter: entityDetails?.costCenter,
            recoveryPriority: entityDetails?.recoveryPriority,
            projectName: entityDetails?.project,
            sector: catalog?.sector,
        },
        tagsQc: { ...catalogConfig?.tags },
        sector: catalog?.sector || null,
        businessCategory: catalogConfig?.tags?.['pep-business-category'] || null,
        environment: environmentDetails?.environment || null,
        region: environmentDetails?.region || null,
        regionDetails: { label: environmentDetails?.region || null, value: environmentDetails?.region || null },
        department: environmentDetails?.department,
        departmentDetails: { label: environmentDetails?.department, value: environmentDetails?.department },
        cluster: environmentDetails?.clusterName,
        clusterDetails: { label: environmentDetails?.clusterName, value: environmentDetails?.clusterName },
        subscriptionId: environmentDetails?.subscriptionId || '',
        appSupportMailId: catalogConfig?.appSupportMailId,
        project: catalogConfig?.project,
        aksNamespace: catalogConfig?.namespace,
        isValidAksNamespace: true,
        nodePool: catalogConfig?.nodePool,
        nodepoolDetails: { label: catalogConfig?.nodePool, value: catalogConfig?.nodePool },
        applicationUrl: catalogConfig?.applicationUrl,
        supportBackendCertificate: catalogConfig?.supportBackendCertificate,
        resourceGroup: environmentDetails?.resourceGroup || null,
        hCode: environmentDetails?.costCenter || null,
        ...(environmentDetails?.costCenter && {
            hCodeDetails: { label: environmentDetails?.costCenter, value: environmentDetails?.costCenter, projectName: environmentDetails?.projectName },
        }),
        ...(!environmentDetails?.costCenter && { hCodeDetails: null }),
        adGroup: catalogConfig?.adGroup || null,
        catalogCode: catalog?.catalogServiceCode,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        catalogType: catalog?.catalogType,
        cloudProvider: catalog?.cloudProvider,
        cloudService: catalog?.cloudService,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};

export const resetOrder = {
    appProfile: null,
    appProfileDetails: null,
    businessCategory: null,
    entityDetails: null,
    sector: null,
    environment: null,
    region: null,
    regionDetails: null,
    applicationOwner: null,
    applicationOwnerDetails: null,
    aksNamespace: null,
    isValidAksNamespace: false,
    nodePool: null,
    nodepoolDetails: null,
    requestType: '',
    department: null,
    departmentDetails: null,
    appSupportMailId: null,
    cluster: null,
    clusterDetails: null,
    project: null,
    hCode: null,
    hCodeDetails: null,
    adGroup: null,
    envDetails: null,
    tags: [],
    estimatedCost: {},
    validationStatus: 'clearValidation',
    isTouched: false,
};

export const resetToggleSspModal = {
    isCost: { costType: '', isCostOpen: false },
    isTagOpen: false,
    isDiskOpen: false,
    isApplicationOpen: false,
    isSubmitOrderSuccess: false,
    isCostSplitOpen: false,
    isDataDisk: { isOpen: false, newDataDiskCount: 0, deleteCount: 0 },
};

export const resetCostEstimateDetails = {
    details: [],
    qty: null,
    totalOneTimeCost: {
        frequency: 'one time',
        estCost: null,
        currency: 'USD',
    },
    totalRecurringCost: {
        frequency: 'monthly',
        estCost: null,
        currency: 'USD',
    },
    notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
};

export const environmentConfigAppURL = {
    development: {
        regex: /^((?:(?!azure|aws|gcp|ite)[a-z0-9-]){3,25})\.dev\.(mypepsico|pepsico|azure\.intra\.pepsico)\.com$/,
        message: `Application URL is Invalid. Must be in the format: <appshortname>.dev.mypepsico.com, <appshortname>.dev.pepsico.com, or <appshortname>.dev.azure.intra.pepsico.com (where <appshortname> is 3–25 lowercase characters, must not contain '.', and may include hyphens). (e.g., devx-infra.dev.mypepsico.com)\nNote: <appshortname> must not contain any cloud-specific terms such as 'azure', 'aws', 'gcp', or 'ite'.`,
    },
    qa: {
        regex: /^((?:(?!azure|aws|gcp|ite)[a-z0-9-]){3,25})\.qa\.(mypepsico|pepsico|azure\.intra\.pepsico)\.com$/,
        message: `Application URL is Invalid. Must be in the format: <appshortname>.qa.mypepsico.com, <appshortname>.qa.pepsico.com, or <appshortname>.qa.azure.intra.pepsico.com (where <appshortname> is 3–25 lowercase characters, must not contain '.', and may include hyphens). (e.g., devx-infra.qa.pepsico.com)\nNote: <appshortname> must not contain any cloud-specific terms such as 'azure', 'aws', 'gcp', or 'ite'.`,
    },
    'pre-production': {
        regex: /^((?:(?!azure|aws|gcp|ite)[a-z0-9-]){3,25})\.preprod\.(mypepsico|pepsico|azure\.intra\.pepsico)\.com$/,
        message: `Application URL is Invalid. Must be in the format: <appshortname>.preprod.mypepsico.com, <appshortname>.preprod.pepsico.com, or <appshortname>.preprod.azure.intra.pepsico.com (where <appshortname> is 3–25 lowercase characters, must not contain '.', and may include hyphens). (e.g., devx-infra.preprod.pepsico.com)\nNote: <appshortname> must not contain any cloud-specific terms such as 'azure', 'aws', 'gcp', or 'ite'.`,
    },
    production: {
        regex: /^((?:(?!azure|aws|gcp|ite)[a-z0-9-]){3,25})\.(mypepsico|pepsico|azure\.intra\.pepsico)\.com$/,
        message: `Application URL is Invalid. Must be in the format: <appshortname>.mypepsico.com, <appshortname>.pepsico.com, or <appshortname>.azure.intra.pepsico.com (where <appshortname> is 3–25 lowercase characters, must not contain '.', and may include hyphens). (e.g., devx-infra.pepsico.com)\nNote: <appshortname> must not contain any cloud-specific terms such as 'azure', 'aws', 'gcp', or 'ite'.`,
    },
};

export const validateAppURL = (url, environment) => {
    const config = environmentConfigAppURL[environment?.toLowerCase()];

    if (!config) {
        return {
            isValid: false,
            message: 'Invalid environment specified',
        };
    }
    let isValid = {
        isValid: true,
        message: '',
    };
    if (url !== null && url !== '') {
        isValid = config.regex.test(url);
    }
    return {
        isValid,
        message: isValid ? 'Valid URL' : config.message,
    };
};
